import "./ant-popconfirm-buttons.css"
import { DatePicker, Button, Modal, Space, Table, Tag, Input,  Form, Upload, message, Popover, Popconfirm, Select  } from "antd"
import { DownloadOutlined, UploadOutlined  } from "@ant-design/icons"

import dayjs from 'dayjs';
import { getUploadFile, getRequests, getSettings, updateSettings, sendToMail, downToMail, getDefinitions, downloadFile } from '../redux/actions/obsAction';
import { getUsers, updateUser } from '../redux/actions/userAction';
import { getPaymentList, getEbarimt} from '../redux/actions/payAction';
import { useState, useEffect } from 'react';
import { connect } from "react-redux";
import Main from "./Main";
import moment from "moment"
import FileDownload from "js-file-download";
const { Option } = Select;
const reducer = ({ user, obs, pay }) => ({  user, obs, pay });
const { RangePicker } = DatePicker;

const Card=(props)=>{
    const MAX_TOTAL_SIZE = 10 * 1024 * 1024; 

    const [checkPay, setCheckPay] = useState("");
    const [form] = Form.useForm();
    const { user, obs, pay } = props
    const [modal, setModal]= useState(false)
    const [userId,setUserId]= useState(0)
    useEffect(()=>{
        props.dispatch(getRequests())
        props.dispatch(getDefinitions())
    },[])

    const onFinish = (values) => {
      if(values.email && userId>0){
        props.dispatch(updateUser({values,id:userId})).then(c=>{
          if( c.success ){
              message.info(c.message , 5);
              setModal(false)
          }
        })
      }
    };

    const onDownloadFileDefinition=(el)=>{
        if(el){
            const filename = el.split("/")
            if(filename.length>4){
                props.dispatch(downloadFile({filename:filename[5]})).then(res=>{
                    FileDownload(res,`${filename[5]}`)
                })
            }
        }
    }

    const onDownloadFile=(val)=>{
      if(checkPay?.checkPayment?.count>0){
          let request = checkPay.request 
          props.dispatch(downToMail(request)).then(res=>{
              FileDownload(res,`${request.id}.${request.fileType}`)
          })
      }
      if(val?.id>0){
          let request = val
          props.dispatch(downToMail(request)).then(res=>{
              FileDownload(res,`${request.id}.${request.fileType}`)
          })
      }
  }


    const columns = [      
      {
        title: '№',
        key: 'number',
        render:(item, record, index)=>(<>{index+1}</>)
      },
        {
            title: 'Хэрэглэгчийн нэр',
            dataIndex: 'firstname',
            key: 'firstname',
            // render: (text) => <a>{text}</a>,
            responsive: ['xl'],
          },
        {
            title: 'Утасны дугаар',
            dataIndex: 'phone',
            key: 'phone',
            // render: (text) => <a>{text}</a>,
        },
        {
            title: 'Имайл',
            dataIndex: 'email',
            key: 'email',
            responsive: ['sm'],
            // render: (text) => <a>{text}</a>,
        },
         {
            title: 'Индекс',
            dataIndex: 'sums',
            key: 'sums',
            responsive: ['xl'],
            render: (record) => 
            (
              (record || []).split(',').length ===1 ? record : `${(record || []).split(',')[0]}..`                       
            )
        },
        {
          title: 'Төлбөрийн төлөв',
          key: 'pay_status',
          dataIndex: 'pay_status',
          responsive: ['sm'],
          filters: [
            {
              text: 'Төлөгдөөгүй',
              value: 'pending',
            },
            {
              text: 'Төлсөн',
              value: 'paid',
            }],
            filterSearch: true,
            onFilter: (value, record) => record.pay_status.includes(value),
          render: (_, { pay_status }) => (
            <>
            {
                (
                    <Tag color={pay_status==="pending"? "red":'green'} key={pay_status}>
                      {pay_status==="pending"? "Төлөгдөөгүй":'Төлсөн'}
                    </Tag>
                  )
            }
            </>
          ),
        },
        {
          title: 'Төлбөрийн дүн',
          dataIndex: 'pay_amount',
          key: 'pay_amount',
          render: (value) => <>{
            value
          }₮</>,
          responsive: ['lg'],
        },
        
        // {
        //     title: 'Эхлэх хугацаа',
        //     dataIndex: 'start_date',
        //     key: 'start_date',
        //     responsive: ['xl'],
        // },
        // {
        //     title: 'Дуусах хугацаа',
        //     dataIndex: 'end_date',
        //     key: 'end_date',
        //     responsive: ['xl'],
        // },
        {
            title: 'Үүсгэсэн хугацаа',
            dataIndex: 'created',
            key: 'created',
            responsive: ['md'],
            // render: (date) => <>{date}</>,
            render: (date) => <>{dayjs(date).add(-8,"hours").format("YYYY-MM-DD HH:mm")}</>,
        },
        {
          title: 'Үйлдэл',
          key: 'action',
          render: (_, record) => (
            <Space direction="horizontal"  size="small">
                <Popover  title="Татаж авах">
                    <Button onClick={()=>onDownloadFile(record)} shape="circle" type="primary" className='border-none bg-blue-500 text-white rounded-md w-full hover:bg-blue-300 hover:text-white duration-300 flex justify-center items-center' icon={<DownloadOutlined />} ></Button>
                </Popover>
            </Space>
          ),
        },
    ];
  
    const columnsDefinition = [
        {
            title: '№',
            key: 'number',
            render:(item, record, index)=>(<>{index+1}</>)
          },
          {
            title: 'Овог нэр',
            dataIndex: 'lastname',
            key: 'lastname',
          },
          {
            title: 'Өөрийн нэр',
            dataIndex: 'firstname',
            key: 'firstname',
          },
          {
            title: 'Цахим шуудан',
            dataIndex: 'email',
            key: 'email',
          },
          {
            title: 'Утас',
            dataIndex: 'phone',
            key: 'phone',
          },
          {
            title: 'Хаан зориулж',
            dataIndex: 'organization',
            key: 'organization',
          },
        {
          title: 'Элемент',
          dataIndex: 'element',
          key: 'element',
        },
    
          {
            title: 'Байршил',
            dataIndex: 'location',
            key: 'location',
          },
      
        {
          title: 'Хамаарах хугацаа',
          dataIndex: 'odate',
          key: 'odate',
          render: (odate) => <div key={odate}>
            {
                odate.split(",").map((el,i)=><p key={i}>{dayjs(el).format("YYYY-MM-DD")}</p>)
            }
          </div>,
        },
        {
          title: 'Нэмэлт тайлбар',
          dataIndex: 'explain',
          key: 'explain',
        },
        {
          title: 'Төлбөрийн төлөв',
          key: 'pay_status',
          dataIndex: 'pay_status',
          responsive: ['lg'],
          filters: [
            {
              text: 'Төлөгдөөгүй',
              value: 'pending',
            },
            {
              text: 'Төлсөн',
              value: 'paid',
            }],
            filterSearch: true,
            onFilter: (value, record) => record.pay_status.includes(value),
            render: (_, { pay_status }) => (
                <>
                {
                    (
                        <Tag color={pay_status==="pending"? "red":'green'} key={pay_status}>
                        {pay_status==="pending"? "Төлөгдөөгүй":'Төлсөн'}
                        </Tag>
                    )
                }
                </>
            ),
        },
        {
            title: 'Төлбөрийн дүн',
            dataIndex: 'pay_amount',
            key: 'pay_amount',
            render: (value) => <>{
              value
            }₮</>,
            // responsive: ['lg'],
          },
          {
            title: 'Файл төлөв',
            // dataIndex: 'fileStatus',
            key: 'fileStatus',
            render: (record, { fileStatus }) => (
              <div key={record.id} className="flex flex-col items-start justify-center text-md">
              {
                  (
                      <Tag color={fileStatus==="inactive"? "red":'green'} key={fileStatus}>
                      {fileStatus==="inactive"? "Илгээгээгүй":'Илгээсэн'}
                      </Tag>
                  )
              }
                <div>
                  {
                    record.fileStatus === "active" &&
                    record.filePath.split(",").map((el,i)=>
                      // <a key={i} target="_blank" href={el}>{i+1},</a>
                      <Popover
                          key={`popov-${i}`}
                          content={"Татах"}>
                          <div key={i} onClick={()=>onDownloadFileDefinition(el)} className="cursor-pointer px-2 bg-blue-500 mt-1 text-white rounded-md">{i+1}</div>
                      </Popover>
                    )
                    
                  }
                </div>
              </div>
          ),
            // responsive: ['lg'],
          },

        {
            title: 'Үүсгэсэн хугацаа',
            dataIndex: 'created',
            key: 'created',
            // responsive: ['xl'],
            render: (date) => <>{dayjs(date).add(-8,'hours').format("YYYY-MM-DD HH:mm")}</>,
        },
        {
          title: 'Үйлдэл',
          key: 'action',
          // width:250,
          fixed: 'right',
        //   responsive: ['sm'],
          render: (record) => (
            <Space direction="vertical"  size="small">
                {
                      <div className='flex flex-col items-start justify-between'>
                        
                        <Upload  {...propsUpload(record)}>
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                        {/* {
                            fileList.length>0&&
                            <Button danger onClick={()=>handleDeleteAll(record)}>
                                Delete All
                            </Button>
                        } */}
                        {
                          (fileList || []).filter(el=>el.id==record.id).length>0 &&
                            <Popconfirm
                              title="Файл илгээх"
                              description="Та энэхүү файлыг илгээх гэж байгаадаа итгэлтэй байна уу?"
                              onConfirm={()=>onSendDefinition(record)}
                              // onCancel={cancel}
                              okText="Тийм"
                              cancelText="Үгүй"
                            >
                              <Button loading={obs?.loading} className="mt-1 bg-green-500 text-white border-none" type="primary">Илгээх</Button>
                            </Popconfirm>
                        }
                      </div>
                        
                        /* <Button onClick={()=>openDrawer(record)} type="primary" className='border-none bg-blue-500 text-white rounded-md w-full hover:bg-blue-300 hover:text-white duration-300 flex justify-center items-center' icon={<PiUploadDuotone />} >Илгээх</Button> */
                }

            </Space>
          ),
        },
    ];
   
   
    const onFilter=()=>{
      if(between?.between){
        if (props.selected==="requests"){
          props.dispatch(getRequests({date:between.between}))
        } else if (props.selected==="users") {
          props.dispatch(getUsers({date:between.between}))
        } else if (props.selected==="paylists") {
          props.dispatch(getPaymentList({date:between.between}))
        }
      }
    }
    const [between, setbetween]= useState()
    const handleSingleChange=(e, type)=>{
        if(e){
            let data = {};
            if(typeof e === 'string'){
                data[type] = e;
            } else if((e || [])[0]){
                data.between = data.between || {};
                data.between.start_date = (e || [])[0];
                data.between.end_date = (e || [])[1];
            } else {
                data[e.target.name] = e.target.value;
            }
            setbetween(data)
        }
    }
    const [fileList, setFileList] = useState([]); // Initialize as an object

    const handleFileChange = (file, record) => {
      setFileList(prev => {
        // Find if record already exists
        const existingRecord = prev.find(item => item.id === record.id);
    
        if (existingRecord) {
          // Update existing record
          return prev.map(item =>
            item.id === record.id
              ? { ...item, files: [...item.files, file] }
              : item
          );
        } else {
          // Add new record
          return [...prev, { id: record.id, files: [file] }];
        }
      });
    };

    const handleRemoveFile = (file, record) => {
      setFileList(prev => {
        return prev
          .map(item =>
            item.id === record.id
              ? { ...item, files: item.files.filter(f => f.uid !== file.uid) }
              : item
          )
          .filter(item => item.files.length > 0); // Remove record if no files left
      });
    };

    const propsUpload = (record) => {

      const recordFiles = (fileList || []).find(item => item.id === record.id)?.files || [];
    
      return {
        name: 'file',
        multiple: true,
        beforeUpload: (file) => {
          const totalSize = recordFiles.reduce((sum, f) => sum + f.size, 0) + file.size;
          if (totalSize > MAX_TOTAL_SIZE) {
            message.warning('Файлын хэмжээ 10 MB-с их байна!', 5);
            return false; // Prevent upload
          }

          handleFileChange(file, record);
          return false; // Prevent automatic upload
        },
        onRemove: (file) => handleRemoveFile(file, record),
        fileList: recordFiles, // Bind files to row
      };
    };
    

    const onSendDefinition = async (record) => {
      const formData = new FormData();
      
      // Find the record's files
      const recordFiles = fileList.find(item => item.id === record.id)?.files || [];
      const totalSize = recordFiles.reduce((sum, f) => sum + (f.size || 0), 0);

      if (totalSize > MAX_TOTAL_SIZE) {
        return message.warning('Нийт файлын хэмжээ 10 MB-с их байна!', 5);
      }

    
      if (recordFiles.length === 0) {
        console.warn("No files to upload for this record");
        return;
      }
          // Append files to FormData
      recordFiles.forEach(file => {
        formData.append("files", file);
      });
      formData.append("email", record.email);
      formData.append("id", record.id);
      props.dispatch(getUploadFile(formData)).then(c=>{
        message.info(c?.message,5)
      })
    };
    return(
        <Space
          direction="vertical"
          className="w-full"
        >
          {
            props.selected==="settings" || props.selected==="dashboard"?
            null
            :
            <Space direction="horizontal">             
              <RangePicker defaultValue={[dayjs((between || {}).start_date || dayjs()), dayjs((between || {}).end_date || dayjs())]} onChange={(e) => handleSingleChange(e, 'between')} />
              <Button type="primary" className="bg-blue-500 border-none text-white hover:bg-blue-400" loading={pay.loading || false} onClick={()=>onFilter()}>Харах</Button>
            </Space>
          }

        {
            props.selected==="requests" ?
            <Table 
                className="w-full h-36" 
                columns={columns} 
                // rowSelection={{}}
                dataSource={obs?.requests || []} 
                expandable={{
                  expandedRowRender: (record) => (
                    <Space
                    direction="vertical"
                    size="small"
                    className="w-auto"
                    
                  >
                    <div>Индекс:{record.sums}</div>
                    <div>Элемент:{record.elements}</div>
                    <div>Мэдээний Хугацаа:{record.start_date}-{record.end_date}</div>
                    <div>Төлбөр:
                      <Tag color={record.pay_status==="pending"? "red":'green'} key={record.pay_status}>
                        {record.pay_status==="pending"? "Төлөгдөөгүй":'Төлсөн'}
                      </Tag>
                    </div>
                    <div>ТөлбөрийнХэжээ:{record.pay_amount}₮</div>
                    </Space>
                  ),
                  // rowExpandable: (record) => 
                  // (
                  //   (record.sums).split(',').length !==1                          
                  // )
                }}
                pagination={{
                    pageSize: 10,
                }}
            />
            : props.selected==="definition"?       
            <>
              <Table 
                key={"definitionList-table"}
                className="w-full h-36" 
                columns={columnsDefinition} 
                dataSource={obs?.definitions || []} 
                scroll={{ x: 'max-content' }}
                pagination={{
                    pageSize: 10,
                }}
              /> 
            </>
           :
            <Main/>
        }
        <Modal cancelButtonProps={{ style: { display: 'none' } }} okButtonProps={{ style: { display: 'none' } }} open={modal} onCancel={()=>setModal(false)} onOk={()=>setModal(false)}>
        <Form  form = {form}
          name="normal_login"
          className="login-form w-full pt-10"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
        >
        <Form.Item
          name="email"
          className="pb-1"
          rules={[
            {
              required: true,
              message: '* Email оруулна уу. ',
            },
            {
              type: 'email',
              message: 'Имайл хаяг оруулна уу.',
            },
          ]}
        >
          <Input type="email" className="py-2" placeholder="Email" />
        </Form.Item>
        <Form.Item
          name="lastname"
          className="pb-1"
          rules={[
            {
              required: true,
              message: '* Овог нэр оруулна уу. ',
            },
          ]}
        >
          <Input  className="py-2" placeholder="Овог нэр" />
        </Form.Item>
        <Form.Item
          name="firstname"
          className="pb-1"
          rules={[
            {
              required: true,
              message: '* Өөрийн нэр оруулна уу. ',
            },
          ]}
        >
          <Input  className="py-2" placeholder="Өөрийн нэр" />
        </Form.Item>
        <Form.Item
          name="phone"
          className="pb-1"
          rules={[
            {
              required: true,
              message: '* Утасны дугаар оруулна уу. ',
            },
          ]}
        >
          <Input type="number" className="py-2" placeholder="Утасны дугаар" />
        </Form.Item>

        {/* <Form.Item
          name="passwordOld"
          className="pb-1"
          hasFeedback
          rules={[
            {
              required: true,
              message: '* Хуучин нууц үг оруулна уу.',
            },
          ]}
        >
          <Input.Password
            className="py-2"
            // prefix={<LockOutlined className="site-form-item-icon" />}
            type="passwordOld"
            placeholder="Хуучин нууц үг"
          />
        </Form.Item> */}

        <Form.Item
          name="password"
          className="pb-1"
          hasFeedback
          rules={[
            {
              required: true,
              message: '* Шинэ нууц үг оруулна уу.',
            },
          ]}
        >
          <Input.Password
            className="py-2"
            // prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Шинэ нууц үг"
          />
        </Form.Item>

        <Form.Item
          name="passwordConfirm"
          dependencies={['password']}
          hasFeedback
          className="pb-1"
          rules={[
            {
              required: true,
              message: '* Шинэ нууц үг оруулна уу.',
            },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('Нууц үг адилхан биш байна.'));
            },
          }),
          ]}
        >
          <Input.Password
            className="py-2"
            // prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Шинэ нууц үг давтах"
          />
        </Form.Item>
 

        <Form.Item>
          <div className="flex flex-col">
            <button htmlType="submit" className="focus:ring-1 ring-blue-700 outline-none bg-blue-500 text-white border border-blue-500 hover:bg-blue-400 py-2 rounded-md duration-300">
                Засах
            </button>
          </div>
        </Form.Item>
        </Form>
        </Modal>

      </Space>
      
    )
}

export default connect(reducer)(Card);